import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type User from 'modules/core/store/models/User'

import type { Employees } from 'modules/employees/store/collections/employees'
import { employeeLocation } from 'modules/locations/store/collections/locations'

interface LocationProps {
  user: User
  employees: Employees
}

function Location({ user, employees }: LocationProps) {
  const employee = user.isNew
    ? undefined
    : employees.find({
        access_id: user.attributes.id,
      })
  const location = employee ? employeeLocation(employee.attributes.location_id) : null

  if (!location) return <>-</>

  return <Text.Normal>{location.attributes.name}</Text.Normal>
}

export default observer(Location)
